// client/src/components/GeneratorForm.jsx
import React, { useState } from 'react';

const tones = ['Professional', 'Casual', 'Creative', 'Persuasive'];

const GeneratorForm = ({ onGenerate, loading }) => {
    const [keyword, setKeyword] = useState('');
    const [tone, setTone] = useState(tones[0]);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (keyword.trim()) {
            onGenerate({ keyword, tone });
        }
    };

    return (
        <form onSubmit={handleSubmit} className="mt-10 flex flex-col md:flex-row gap-6 max-w-2xl mx-auto bg-white/80 p-6 rounded-xl shadow-lg border border-indigo-100">
            <input
                type="text"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="Enter keyword/topic (e.g., 'digital marketing trends')"
                className="flex-grow p-4 border-2 border-indigo-300 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 shadow-md text-lg placeholder:text-indigo-400"
                required
                disabled={loading}
            />
            <select
                value={tone}
                onChange={(e) => setTone(e.target.value)}
                className="p-4 border-2 border-indigo-300 rounded-xl focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 shadow-md text-lg md:w-44 bg-indigo-50"
                disabled={loading}
            >
                {tones.map(t => (
                    <option key={t} value={t}>{t}</option>
                ))}
            </select>
            <button
                type="submit"
                className="bg-gradient-to-r from-indigo-600 to-indigo-500 hover:from-indigo-700 hover:to-indigo-600 text-white font-bold py-4 px-8 rounded-xl shadow-lg transition duration-200 disabled:opacity-50 md:w-36 text-lg"
                disabled={loading}
            >
                {loading ? 'Generating...' : 'Generate'}
            </button>
        </form>
    );
};

export default GeneratorForm;